import Alert from "@mui/material/Alert";
import XMarkIcon from "@mui/icons-material/Close";
import CheckIcon from "@mui/icons-material/Check";
import React from "react";
import ReviewIconButton from "./ReviewIconButton";
import { describeApiError } from "../api/request";
export default function VariationReviewRow({
  variation,
  filter,
  pending,
  error,
  disabled,
  onDecision,
}) {
  return (
    <li
      className="variation-review-row"
      data-variation-id={variation.id}
      aria-busy={pending || undefined}
    >
      <div className="variation-name">
        <span>{variation.name}</span>
        {filter !== "unreviewed" && (
          <small className="variation-status">{variation.status}</small>
        )}
        {pending && <small role="status">Saving…</small>}
        {error && (
          <Alert role="alert" severity="error">
            {describeApiError(error)}
          </Alert>
        )}
      </div>
      <div className="review-actions">
        {variation.status !== "allowed" && (
          <ReviewIconButton
            label={`Approve ${variation.name}`}
            icon={CheckIcon}
            disabled={disabled || pending}
            data-review-action
            onClick={() => onDecision("allowed")}
          />
        )}
        {variation.status !== "blocked" && (
          <ReviewIconButton
            label={`Reject ${variation.name}`}
            icon={XMarkIcon}
            disabled={disabled || pending}
            data-review-action
            onClick={() => onDecision("blocked")}
          />
        )}
      </div>
    </li>
  );
}
